import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CompassOutlined, TeamOutlined } from '@ant-design/icons';

export const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="bg-slate-50 text-slate-900 font-sans p-6"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box'
      }}
    >
      <div 
        style={{
          width: '100%',
          maxWidth: '1024px', // max-w-5xl equivalent
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '40px', width: '100%', maxWidth: '800px' }}>
          <span style={{
            fontSize: '0.75rem',
            fontWeight: 900,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            backgroundColor: '#eef2f6',
            color: '#4f46e5',
            padding: '4px 12px',
            borderRadius: '9999px',
            border: '1px solid #e2e8f0',
            display: 'inline-block'
          }}>
            Astrologi Klasik & Artificial Intelligence
          </span>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            fontWeight: 900,
            letterSpacing: '-0.02em',
            margin: '12px 0 8px 0',
            color: '#0f172a'
          }}>
            BaZi Insights Platform
          </h1>
          <p style={{
            color: '#64748b',
            fontSize: '0.875rem',
            fontWeight: 500,
            maxWidth: '512px',
            margin: '0 auto',
            lineHeight: 1.6
          }}>
            Pilih portal pengerjaan kamu: analisis karir dan coaching mandiri (PERSONAL) atau screening kandidat HR tingkat perusahaan (ENTERPRISE).
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
          {/* PERSONAL Card */}
          <div className="bg-white border-2 border-slate-900 rounded-2xl p-6 flex flex-col justify-between shadow-[6px_6px_0_#1a202c] transition-all hover:-translate-y-1 hover:shadow-[8px_8px_0_#1a202c]">
            <div className="space-y-4">
              <div className="w-12 h-12 rounded-xl bg-amber-100 border-2 border-slate-900 flex items-center justify-center shadow-[3px_3px_0_#1a202c] text-amber-600">
                <CompassOutlined style={{ fontSize: 24 }} />
              </div>
              <div>
                <h2 className="text-xl font-black text-slate-900"><CompassOutlined style={{ marginRight: 6 }} /> Portal Personal (PERSONAL)</h2>
                <p className="text-xs font-bold text-slate-500 mt-1">
                  Koin Wallet • AI Coaching • Analisis Fase Hidup
                </p>
              </div>
              <p className="text-sm text-slate-600 leading-relaxed font-medium">
                Pelajari bagan BaZi personal kamu, cari tahu rekomendasi karir tahun ini, isi kuesioner Wu Xing, dan tanyakan nasihat hidup langsung ke AI Coaching.
              </p>
            </div>
            <button 
              onClick={() => navigate('/personal/dashboard')}
              className="w-full mt-8 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-extrabold text-sm border-2 border-slate-900 rounded-xl shadow-[3px_3px_0_#1a202c] active:translate-y-0.5 active:shadow-[1px_1px_0_#1a202c] transition-all cursor-pointer"
            >
              Masuk Portal Personal
            </button>
          </div>

          {/* ENTERPRISE Card */}
          <div className="bg-slate-900 text-slate-100 border-2 border-slate-950 rounded-2xl p-6 flex flex-col justify-between shadow-[6px_6px_0_#1a202c] transition-all hover:-translate-y-1 hover:shadow-[8px_8px_0_#1a202c]">
            <div className="space-y-4">
              <div className="w-12 h-12 rounded-xl bg-indigo-500/20 border-2 border-slate-950 flex items-center justify-center shadow-[3px_3px_0_#1a202c] text-indigo-400">
                <TeamOutlined style={{ fontSize: 24 }} />
              </div>
              <div>
                <h2 className="text-xl font-black text-white"><TeamOutlined style={{ marginRight: 6 }} /> Portal HR & Developer (ENTERPRISE)</h2>
                <p className="text-xs font-bold text-indigo-300 mt-1">
                  Screening Pelamar • Webhook • Odoo Sync • API Keys
                </p>
              </div>
              <p className="text-sm text-slate-400 leading-relaxed font-medium">
                Portal evaluasi kandidat bertenaga BaZi. Upload dokumen batch CSV pelamar, petakan keseimbangan elemen tim, dan kelola API Keys untuk integrasi HRIS.
              </p>
            </div>
            <button 
              onClick={() => navigate('/enterprise/dashboard')}
              className="w-full mt-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-extrabold text-sm border-2 border-slate-950 rounded-xl shadow-[3px_3px_0_#1a202c] active:translate-y-0.5 active:shadow-[1px_1px_0_#1a202c] transition-all cursor-pointer"
            >
              Masuk Portal Enterprise
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LandingPage;
